<template>
  <div v-if="item">
    <timetable-template :id="id" v-model="item.timetable" />
    <div class="save-panel">
      <button class="btn btn-success btn-icon mb-3 mr-2" @click="updateItem">
        <span class="ti-save"></span>{{ "save" | setText("Сохранить") }}
      </button>
    </div>
  </div>
</template>

<script>
import { cardUpdate, cardContent, errorNotify } from "@/plugins/functions";

export default {
  props: {},
  data: () => ({
    timetable: [],
    itemLink: "business/groups/timetable",
    item: null,
    fields: [],
  }),
  components: {
    "timetable-template": () => import("./Timetable/TimetableTemplate"),
  },

  props: ["id"],
  async created() {
    this.itemLink = `business/groups/${this.id}/timetables`;
    this.item = await this.cardContent(this.itemLink);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    async updateItem() {
      this.$loading(true);
      let item = await this.$http
        .put(`${this.itemLink}/${this.item.id}`, this.item)
        .then(() => {
          this.$notify({
            title: "Успешно",
            message: "расписание успешно сохранено",
            icon: "ti-save",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success",
          });
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
        });

      if (item && item.id) {
        this.item = item;
      }
    },
  },
};
</script>
<style>
</style>
